export const BASE_CLASS = 'mt-StepperFlow'
